import { apiUrls } from '../../../utils/constants/urls'
import { toast } from 'react-toastify'

let metaAbortController = new AbortController() 
const getFacilityListMetadata = (authFetch, API_URL, queryParameters, after) => {
    const queryString = new URLSearchParams(queryParameters).toString()
    metaAbortController.abort()
    const abortController = new AbortController()
    metaAbortController = abortController
    authFetch(
        `${API_URL}/${apiUrls.facility}/listMeta/?${queryString}`,
        { signal: abortController.signal }
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            if (e.name !== 'AbortError') { 
                toast({
                    level: 'error',
                    message:
                        'Facility: ' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server. Please try again later.'),
                })
            }
        })
}

let dataAbortController = new AbortController()
const getFacilities = (authFetch, API_URL, queryParameters, after) => {
    const queryString = new URLSearchParams(queryParameters).toString()
    dataAbortController.abort()
    const abortController = new AbortController()
    dataAbortController = abortController
    authFetch(
        `${API_URL}/${apiUrls.facility}?${queryString}`,
        { signal: abortController.signal }
    )
        .then(async (response) => {
            if (response.ok) {
                return response.json()
            } else {
                const error = await response.text()
                throw new Error(error)
            }
        })
        .then((response) => {
            after(response)
        })
        .catch((e) => {
            if (e.name !== 'AbortError') { 
                toast({
                    level: 'error',
                    message:
                        'Facility: ' +
                        (e.message
                            ? e.message
                            : 'Unable to connect to the server. Please try again later.'),
                })
            }
        })
}

export { getFacilities, getFacilityListMetadata }
